const keys = {
  up: 'ArrowUp',
  down: 'ArrowDown',
  right: 'ArrowRight',
  left: 'ArrowLeft',
  enter: 'Enter',
  space: ' ',
  shift: 'Shift',
  pageDown: 'PageDown',
  pageUp: 'PageUp',
  home: 'Home',
  end: 'End'
};
var keyConstants = keys;

export { keyConstants as default };
